import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  img: {
    width: 250,
  },
  title: {
    fontSize: 24,
    marginTop: 40,
    fontWeight: 600,
    color: "#132B50",
  },
}));

export default useStyles;
